import React, { useState } from 'react';
import loadable from '@loadable/component';

import useIsCartOpen from 'global-state/isCartOpen/useIsCartOpen';
import useCloseCart from 'global-state/isCartOpen/useCloseCart';
import Cart from 'components/consumer/cart';
import SidebarModal from 'components/consumer/SidebarModal';
import withBrowserOnly from 'components/hoc/withBrowserOnly';

const ShareModal = loadable(() =>
  import('components/consumer/cart/share-modal')
);

const CartModalUI = () => {
  const isCartOpen = useIsCartOpen();
  const closeCart = useCloseCart();

  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [lockScrollWhenOpen, setLockScrollWhenOpen] = useState(true);

  return (
    <SidebarModal
      isOpen={isCartOpen}
      onClose={closeCart}
      mobileIsFullHeight
      desktopNoPadding
      lockScrollWhenOpen={lockScrollWhenOpen}
    >
      <Cart
        stickyFooter={false}
        openShareModal={() => {
          setIsShareModalOpen(true);
        }}
        setLockScrollWhenOpen={setLockScrollWhenOpen}
      />

      {isShareModalOpen && (
        <ShareModal
          closeShareModal={() => {
            setIsShareModalOpen(false);
          }}
          closeSidebar={() => {
            setIsShareModalOpen(false);
            closeCart();
          }}
        />
      )}
    </SidebarModal>
  );
};

export default withBrowserOnly(CartModalUI);
